import { identificarTotem, sincronizarCompra } from "@/posthog";

// O plugin roda na criação da store, antes de qualquer tela. Um localStorage
// indisponível (navegador com armazenamento bloqueado, ambiente sem DOM) fazia
// a criação da store lançar e derrubar o totem inteiro — só para descobrir um
// identificador de telemetria.
function totemIdLembrado() {
  try {
    return localStorage.getItem("totemId");
  } catch (_) {
    return null;
  }
}

// Mantém os identificadores do PostHog colados no estado do totem em vez de
// espalhar identify/register pelas telas: o fluxo cria, restaura (snapshot do
// Firestore) e reseta a compra em vários pontos, e um subscriber cobre todos.
export default function pluginPostHog(store) {
  const sincroniza = () => {
    const totemId =
      store.state.totem.token ||
      store.state.totem.totem.id ||
      totemIdLembrado();

    const franqueado = store.state.totem.totem.franqueado;
    identificarTotem(totemId, franqueado ? { franqueado } : {});

    sincronizarCompra(store.state.compra.compra.id);
  };

  // O totem pode vir do localStorage num reload, antes de qualquer mutation.
  sincroniza();
  store.subscribe(sincroniza);
}
